import * as React from "react";
import { INTRO, JOBS } from "../raw_cv.js";
import Experience from "../components/Experience";
import Navigation from "../components/Navigation";
import Skills from "../components/Skills";
import Education from "../components/Education";
import Footer from "../components/Footer";
import "../css/cv.scss";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <Navigation />
        <section className="about" id="about">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h3 className="about__name">
                  <span>Alexander M. Chan</span>
                </h3>
                <h4 className="about__short">
                  Software Architect and Full Stack Developer
                </h4>
                <p>{INTRO}</p>
              </div>
              {/* col-md-6 end */}
            </div>
            {/* ROW END */}
          </div>
          {/* CONTAINER END */}
        </section>

        <Experience jobs={JOBS} />
        <Skills />
        <Education />
        <Footer />
      </div>
    );
  }
}

export default App;
